import { PasswordBox } from "@core/components/alt-ui/controls";
import { FormFieldControl } from "../form-field-control";
import { Uuid } from "@/utils/uuid";

export class PasswordBoxFormFieldControl extends FormFieldControl<PasswordBox> {
    protected convert(): PasswordBox {
        const control = new PasswordBox();
        control.id = `${this.field.id}_${Uuid.short()}`;
        control.label = this.field.title ?? "";
        control.help = this.field.description ?? "";
        control.validation = this.validationToString(this.field.validation);
        control.text = this.field.default ?? "";
        return control;
    }

    public get value(): any {
        return this.control.text;
    }

    public set value(value: any) {
        this.control.text = value ? String(value) : "";
    }

    public get hasValue(): boolean {
        return this.value.length > 0;
    }
}
